import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { DrawOptionsInstanceDTO } from '../draw-options-dtos';
import { DataType, DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-draw-options-form-field',
  templateUrl: './draw-options-form-field.component.html',
  styleUrls: ['./draw-options-form-field.component.scss'],
  standalone: false,
})
export class DrawOptionsFormFieldComponent extends DataTypeComponent implements OnInit {
  @Input() data: DrawOptionsInstanceDTO[];

  @Input() editMode: boolean;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() formGroup: UntypedFormGroup;

  public tableData: MatTableDataSource<any>;

  public displayedFieldsNames: string[];

  public fields: FieldConfigDTO[];

  ngOnInit() {
    this.formGroup.get(this.fieldConfig.name).setValue(this.data);
    this.fields = [
      {
        name: 'id',
        label: 'Id',
        type: DataType.text,
      },
      {
        name: 'optionType',
        label: 'Option type',
        type: DataType.text,
      },
      {
        name: 'primaryDraw',
        label: 'Primary draw',
        type: DataType.number,
      },
      {
        name: 'minRange',
        label: 'Min range',
        type: DataType.number,
      },
      {
        name: 'maxRange',
        label: 'Max range',
        type: DataType.number,
      },
      {
        name: 'price',
        label: 'Price',
        type: DataType.money,
        moneyFormat: 'ticketPrice',
      },
      {
        name: 'optional',
        label: 'Optional',
        type: DataType.checkbox,
      },
    ];
  }

  onValueChanged(value: any[] | any) {
    const formControl = this.formGroup.get(this.fieldConfig.name);
    const oldValue: DrawOptionsInstanceDTO[] = value;
    formControl.setValue(oldValue);
  }
}
